import { ListaPartidos } from '../constantes/Filtros.js';
import * as TipoRival from '../constantes/TipoRival.js';
import * as DTOs from '../DTOs/PartidoDTOs.js';
import { Method } from './DataUtils.js';
import * as DataUtils from './DataUtils.js';

const TipoURL = {
  TOTALES: 'totales',
  CANTIDAD: 'cantidad',
  LISTA: 'lista',
};

export const PathClubTipoRival = (idClub, tipoRival) => {
  let path = '';
  if (tipoRival) {
    path = 'clubes/' + idClub + '/rivales/';
    switch (tipoRival) {
      case TipoRival.CLUB: {
        path += 'clubes';
        break;
      }
      case TipoRival.EQUIPO: {
        path += 'equipos';
        break;
      }
      case TipoRival.SELECCION: {
        path += 'equipos';
        break;
      }
      default: {
        path = null;
      }
    }
  } else {
    path = 'clubes';
  }
  return path;
};

const URLPartidos = (item, id, filtro, tipoURL, pagina, cantItems, idCategoria) => {
  let url = item + '/' + id + '/partidos';
  let separador = '?';
  if (filtro !== null && Number(filtro) === ListaPartidos.AMISTOSOS) {
    url += '/amistosos';
  }
  if (tipoURL === TipoURL.CANTIDAD) {
    url += '/cantidad';
  } else if (tipoURL === TipoURL.TOTALES) {
    url += '/totales';
  }
  if (idCategoria != null) {
    url += separador + 'categoria=' + idCategoria;
    separador = '&';
  }
  if (filtro !== null && filtro > 0) {
    url += separador + 'agrupacion=' + filtro;
    separador = '&';
  }
  if (tipoURL === TipoURL.LISTA) {
    url += separador + 'pagina=' + pagina + '&items=' + cantItems;
  }
  return url;
};

export const URLCantPartidos = (item, id, filtro, idCategoria) => {
  return URLPartidos(item, id, filtro, TipoURL.CANTIDAD, null, null, idCategoria);
};

export const URLListaPartidos = (item, id, filtro, pagina, cantItems, idCategoria) => {
  return URLPartidos(item, id, filtro, TipoURL.LISTA, pagina, cantItems, idCategoria);
};

export const URLTotalesPartidos = (item, id, filtro, idCategoria) => {
  return URLPartidos(item, id, filtro, TipoURL.TOTALES, null, null, idCategoria);
};

export const FetchPartido = (idPartido) => {
  return DataUtils.FetchLista('partidos/' + idPartido);
};

export const FetchFormacion = (idPartido, idEquipo) => {
  return DataUtils.FetchLista('partidos/' + idPartido + '/formaciones/equipos/' + idEquipo);
};

export const FetchGoles = (idPartido) => {
  return DataUtils.FetchLista('partidos/' + idPartido + '/goles');
};

export const FetchResultados = (idPartido) => {
  return DataUtils.FetchLista('partidos/' + idPartido + '/resultados');
};

export const PostResultado = async (idPartido, resultado) => {
  return DataUtils.SaveObject(
    Method.POST,
    'partidos/' + idPartido + '/resultados',
    DTOs.resultadoPartido(resultado, idPartido)
  );
};

export const PutResultado = async (idPartido, resultado) => {
  return DataUtils.SaveObject(
    Method.PUT,
    'partidos/' + idPartido + '/resultados/' + resultado.id,
    DTOs.resultadoPartido(resultado, idPartido)
  );
};

export const DeleteResultado = async (idPartido, idResultado) => {
  return DataUtils.SaveObject(
    Method.DELETE,
    'partidos/' + idPartido + '/resultados/' + idResultado,
    null
  );
};

export const FetchSustituciones = (idPartido) => {
  return DataUtils.FetchLista('partidos/' + idPartido + '/sustituciones');
};

export const GetTotalExpulsionesPersona = async (idPersona) => {
  return DataUtils.FetchObject('personas/' + idPersona + '/expulsiones/cantidad');
};

export const GetTotalGolesJugador = async (idPersona) => {
  return DataUtils.FetchObject('jugadores/' + idPersona + '/goles/cantidad');
};

export const GetTotalPartidosClub = async (idClub, filtro, tipoRival, idRival, idCategoria) => {
  if (tipoRival) {
    const path = PathClubTipoRival(idClub, tipoRival);
    return path ? DataUtils.FetchObject(URLCantPartidos(path, idRival, filtro, idCategoria)) : 0;
  } else {
    return DataUtils.FetchObject(URLCantPartidos('clubes', idClub, filtro, idCategoria));
  }
};

export const GetTotalPartidosEstadio = async (idEstadio) => {
  return DataUtils.FetchObject('estadios/' + idEstadio + '/partidos/cantidad');
};

export const GetTotalPartidosArbitro = async (idPersona, filtro) => {
  return DataUtils.FetchObject(URLCantPartidos('personas_arbitro', idPersona, filtro));
};

export const GetTotalPartidosJugador = async (idPersona, filtro) => {
  return DataUtils.FetchObject(URLCantPartidos('jugadores', idPersona, filtro));
};

export const GetTotalPartidosPersona = async (idPersona, filtro) => {
  return DataUtils.FetchObject(URLCantPartidos('personas', idPersona, filtro));
};

export const GetTotalPartidosTecnico = async (idPersona, filtro) => {
  return DataUtils.FetchObject(URLCantPartidos('tecnicos', idPersona, filtro));
};

export const PatchParticipanteAmonestado = async (idPartido, idEquipo, participante) => {
  return await DataUtils.SaveObject(
    Method.PATCH,
    'partidos/' + idPartido + '/formaciones/' + participante.idPartidoFormacion,
    DTOs.patchFormacionAmonestado(participante)
  );
};

export const PatchPartido = async (idPartido, dto) => {
  return await DataUtils.SaveObject(Method.PATCH, 'partidos/' + idPartido, dto);
};

export const DeleteExpulsion = async (idPartido, idExpulsion) => {
  return await DataUtils.SaveObject(
    Method.DELETE,
    'partidos/' + idPartido + '/expulsiones/' + idExpulsion,
    null
  );
};

export const PostExpulsion = async (idPartido, datosExpulsion) => {
  return await DataUtils.SaveObject(
    Method.POST,
    'partidos/' + idPartido + '/expulsiones',
    DTOs.expulsionPartido(datosExpulsion)
  );
};

export const PutExpulsion = async (idPartido, datosExpulsion) => {
  return await DataUtils.SaveObject(
    Method.PUT,
    'partidos/' + idPartido + '/expulsiones/' + datosExpulsion.id,
    DTOs.expulsionPartido(datosExpulsion)
  );
};

export const PostFormacion = async (idPartido, idEquipo, formacion) => {
  return await DataUtils.SaveObject(
    Method.POST,
    'partidos/' + idPartido + '/formaciones/equipos/' + idEquipo,
    DTOs.formacionPartido(formacion)
  );
};

export const PutFormacion = async (idPartido, idEquipo, formacion) => {
  return await DataUtils.SaveObject(
    Method.PUT,
    'partidos/' + idPartido + '/formaciones/equipos/' + idEquipo,
    DTOs.formacionPartido(formacion)
  );
};

export const DeleteFormacion = async (idPartido, idFormacion) => {
  return await DataUtils.SaveObject(
    Method.DELETE,
    'partidos/' + idPartido + '/formaciones/' + idFormacion,
    null
  );
};

export const DeleteGol = async (idPartido, idGol) => {
  return await DataUtils.SaveObject(
    Method.DELETE,
    'partidos/' + idPartido + '/goles/' + idGol,
    null
  );
};

export const PostGol = async (idPartido, datosGol) => {
  return await DataUtils.SaveObject(
    Method.POST,
    'partidos/' + idPartido + '/goles',
    DTOs.insertGolPartido(datosGol)
  );
};

export const PutGol = async (idPartido, datosGol) => {
  return await DataUtils.SaveObject(
    Method.PUT,
    'partidos/' + idPartido + '/goles/' + datosGol.id,
    DTOs.updateGolPartido(datosGol)
  );
};

export const DeleteSustitucion = async (idPartido, idSustitucion) => {
  return await DataUtils.SaveObject(
    Method.DELETE,
    'partidos/' + idPartido + '/sustituciones/' + idSustitucion,
    null
  );
};

export const PostSustitucion = async (idPartido, datosSustitucion) => {
  return await DataUtils.SaveObject(
    Method.POST,
    'partidos/' + idPartido + '/sustituciones',
    DTOs.sustitucionPartido(datosSustitucion)
  );
};

export const PutSustitucion = async (idPartido, datosSustitucion) => {
  return await DataUtils.SaveObject(
    Method.PUT,
    'partidos/' + idPartido + '/sustituciones/' + datosSustitucion.id,
    DTOs.sustitucionPartido(datosSustitucion)
  );
};
